import timelineSteps from '@/library/timelineSteps'

function lastEl(arr) {
  return arr[arr.length - 1]
}

export default {
  allTasks: () => {
    return timelineSteps.flatMap(t => t.tasks)
  },
  currentUserProfile: state => {
    return state.route.query?.uid ? state.queriedUserProfile : state.userProfile;
  },
  packages: state => {
    return state.packages
  },
  getStepText: () => step => {
    const group = timelineSteps.find(g => g.tasks.some(t => t.step === step))
    return group?.tasks[0].text
  },
  getStepOwner: () => step => {
    return timelineSteps.find(g => g.tasks.some(t => t.step === step))?.owner
  },
  totalSteps: (state, getters) => {
    return lastEl(getters.allTasks).step
  },
}
